import React from "react";

const Header = ({ setActiveTab }: { setActiveTab: React.Dispatch<React.SetStateAction<string>> }) => {
  return (
    <div>
      <div
        id="Header"
        className="mx-12 lg:mx-60 pt-24 lg:pt-40 lg:w-1/2 text-left"
      >
        <div className="mainIntro">
          <div className="flex flex-col">
            <code className="text-lightblue_vs">Hi, my name is</code>
            <code className="text-[#e6f1ff] text-5xl sm:text-6xl lg:text-7xl mt-5">Manan Sharma</code>
          </div>
          <button
            onClick={() => setActiveTab("projects")}
            className="border border-lightblue_vs text-lightblue_vs mt-10 px-6 py-3 rounded hover:bg-opacity-10 hover:bg-lightblue_vs"
          >
            <code>Check out my Projects</code>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Header;
